module.exports = __webpack_public_path__ + "static/media/noInformation01.0adb4206.png";